<template >
  <!-- Check if results should be shown (after data has been fetched) until then, show the spinner -->
  <div v-if="showResults" >
    <!-- Show tabs if more than one product option is returned -->
    <div v-if="products.length > 1">
        <div class="results-header">
          <h2 v-html="text.multipleResultsTitle"></h2>
          <p v-html="text.multipleResultsSubtitle"></p>
          <button @click="showComparisonChart = !showComparisonChart" v-if="showComparisonChart"><arrow-left-thick-icon /> {{text.compareOptionsBackButton}}</button>
          <button @click="showComparisonChart = !showComparisonChart" v-else>{{text.compareOptionsButton}} <arrow-right-thick-icon /></button>
        </div>
      <Transition name="fade"><ProductsComparisonChart  v-if="(showComparisonChart && products.length > 0)" :products="products" :desiredProducts="desiredProducts" :textStrings="text" /></Transition>
      <Transition name="fade">
      <tabs  v-if="!showComparisonChart" :options="{ useUrlFragment: false }">
        <tab  v-for="product in products" :key="product.name" :name="product.name">
          <Product v-if="showResults" :product="product" :borrower="borrower" :textStrings="text" />
        </tab>
      </tabs>
      </Transition>
    </div>

    <!-- If only one product is returned, show it -->
    <div v-else-if="products.length == 1" v-for="product in products" :key="product.name" :name="product.name">
      <h2 v-html="text.singleResultTitle"></h2>
      <Product :product="product" :borrower="borrower" :textStrings="text" />
    </div>

    <!-- If no products are returned, display a custom message -->
    <div v-else>
      <div class="app-error">
        <h2 v-html="text.errors.noProductsFoundTitle"></h2>
        <div v-html="text.errors.noProductsFoundText"></div>
      </div>
    </div>

    <!-- Always show a thank you no matter how many products are returned-->
    <div class="results-thankyou">
      <h2 v-html="text.thankYouTitle"></h2>
      <div class="thankyou-text" v-html="text.thankYouText"></div>
    </div>
  </div>

  <!-- Show spinner while data is being fetched -->
  <div v-else class="loading-container">
    <pulse-loader :loading=true color="#1D314B" size="3vw"></pulse-loader>
    <h3>{{text.loadingText}}</h3>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import ArrowRightThickIcon from 'vue-material-design-icons/ArrowRightThick.vue'
import ArrowLeftThickIcon from 'vue-material-design-icons/ArrowLeftThick.vue'
import { fetchBaselineCalculations } from './inc/baseline.js'
import { validateHomeValue, validateMortgageBalance, validateYoungestBorrower, validateState, validateURL } from './inc/helpers.js'
import { getOrganizedProducts } from './inc/products.js'
import 'vue-material-design-icons/styles.css'

import { Tabs, Tab } from 'vue3-tabs-component'
import Product from './components/Product.vue'
import ProductsComparisonChart from './components/ProductsComparisonChart.vue'
import textStrings from './data/textStrings.json'
import desiredProducts from './data/desiredProducts.json'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    PulseLoader,
    ArrowRightThickIcon,
    ArrowLeftThickIcon,
    Tabs,
    Tab,
    ProductsComparisonChart,
    Product
  },
  props: ['homevalue', 'mortgagebalance', 'youngestborrowerage', 'state', 'textstringsfile'],
  data () {
    return {
      products: Array,
      showComparisonChart: false,
      showResults: false,
      text: textStrings,
      desiredProducts: desiredProducts,
      borrower: Object
    }
  },
  methods: {
    tabClicked (selectedTab) {
    },
    tabChanged (selectedTab) {
    }
  },
  mounted () {
    if (validateURL(this.textstringsfile)) {
      axios.get(this.textstringsfile)
        .then(response => {
          const customTextStrings = Object.assign({}, this.text, response.data)
          this.text = customTextStrings
        })
    }
    this.borrower = {
      homeValue: validateHomeValue(this.homevalue),
      mortgageBalance: validateMortgageBalance(this.mortgagebalance),
      age: validateYoungestBorrower(this.youngestborrowerage),
      state: validateState(this.state)
    }
    fetchBaselineCalculations(this.borrower)
      .then((response) => {
        this.products = getOrganizedProducts(response, desiredProducts)
        this.showResults = true
      })
      .catch((error) => {
        console.error('Error fetching data', error)
      })
  }

}
</script>

<style lang="scss">
@import "./assets/scss/_variables.scss";
@import "./assets/scss/_components.scss";
</style>
